<template>
    <div class="container-fluid">
        <div class="row">
            <FormReceipt ref="formReceiptRef" v-model:products="formReceipt"/>
            <DomeReceipt ref="domeReceiptRef" v-model:products="domeReceipt" :recive_date="formReceipt.receivedDate"/>
        </div>
        <button class="btn btn-success pull-right mb-3" type="button" @click="submitForm"><span v-if="isSubmitting">กำลังบันทึก...</span><span v-else>บันทึก</span></button>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { directus } from "@/services/directus"
import { readItems , createItems } from "@directus/sdk"
import Swal from 'sweetalert2'
const FormReceipt = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormReceipt.vue"))
const DomeReceipt = defineAsyncComponent(() => import("@/components/theme/receipt-product/DomeReceipt.vue"))

const formReceiptRef = ref(null);
const formReceipt = ref([]);
const domeReceipt = ref([]);
const domeReceiptRef = ref(null);
const isSubmitting = ref(false);

const submitForm = async () => {
    if (isSubmitting.value) return;
    isSubmitting.value = true;
    await addPorducts();
    isSubmitting.value = false;
};

async function checklist(group_product) {
    try {
        const response = await directus.request(
            readItems('check_lists', {
                fields: ["check_list"],
                filter: {
                    type : {
                        _eq : group_product
                    }
                },
                limit: -1
            })
        );
        return response[0].check_list

    } catch (error) {
        return null
    }
}

async function addPorducts() {
    const stockItems = []
    const requiredFields = ["receivedDate", "supplierName", "poNumber", "taxInvoiceNumber", "invoiceDate"];

    const hasEmptyValue = requiredFields.some(key => 
        formReceipt.value[key] === "" || formReceipt.value[key] === null || formReceipt.value[key] === undefined
    );
    
    const hasEmptySerialNumber = domeReceipt.value.some(product =>
        product.serialNumbers.some(serial => serial.trim() === "")
    );
    

    if (hasEmptyValue || hasEmptySerialNumber) {
        errorAlert();
        return;
    }

    for (let i = 0; i < domeReceipt.value.length; i++) {
        for (let j = 0; j < domeReceipt.value[i].serialNumbers.length; j++) {
            const serialNumber = domeReceipt.value[i].serialNumbers[j].trim();
            if (!serialNumber) continue;

            const timestamp = new Date().toISOString().split('.')[0];
            const user = localStorage.getItem('user_full_name');
            const history = [
                {
                    "transaction_type": "added",
                    "timestamp": timestamp,
                    "remarks": "เพิ่มเข้า stock",
                    "user": user
                }
            ]

            const checklistData = await checklist(domeReceipt.value[i].productModel);
            const stockItem = {
                receive_date: formReceipt.value.receivedDate || null,
                name_supplier: formReceipt.value.supplierName || null,
                bill_lading_number: formReceipt.value.deliveryNumber || null,
                bill_lading_number_date: formReceipt.value.deliveryDate || null,
                invoice_number: formReceipt.value.taxInvoiceNumber || null,
                invoice_number_date: formReceipt.value.invoiceDate || null,
                receipt_number: formReceipt.value.receiptNumber || null,
                receipt_number_date: formReceipt.value.receiptDate || null,
                bill_number: formReceipt.value.billingNumber || null,
                due_date: formReceipt.value.dueDate || null,
                po_number: formReceipt.value.poNumber || null,
                product_code_office_design: domeReceipt.value[i].productCode || null,
                product_name_office_design: domeReceipt.value[i].productName || null,
                serial_number: domeReceipt.value[i].serialNumbers[j] || null,
                group_product: domeReceipt.value[i].productModel || null,
                model: domeReceipt.value[i].productBrand|| null,
                device_status: formReceipt.value.statusProduct,
                status: 'รอตรวจสอบอุปกรณ์',
                checklist: checklistData || [],
                history: history,
                shelf: domeReceipt.value[i].shelf || null,
            }            
        stockItems.push(stockItem);
        }
    }
    
    try {
        const result = await directus.request(createItems('stock', stockItems));
        successAlert()
    } catch (error) {
        dangerAlert()
        console.error('Error creating article:', error);
    }
}

function successAlert() {
    Swal.fire({
        icon: "success",
        title: "อัพเดทสำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    }).then(() => {
        formReceiptRef.value?.resetForm();
        domeReceiptRef.value?.resetForm();
        formReceipt.value = [];
        domeReceipt.value = [];
    });
}

function errorAlert() {
    Swal.fire({
        icon: "error",
        title: "กรุณากรอกข้อมูลให้ครบ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}

function dangerAlert() {
    Swal.fire({
        icon: "error",
        title: "อัพเดทข้อมูลไม่สำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}
</script>